import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'
export const Number: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
  }
> = ({ name, defaultValue, errors, label, register, required, width }) => {
  const placeholder = required ? `${label} *` : label

  return (
    <Width width={width}>
      <Label className="sr-only" htmlFor={name}>
        {label}
        {required && <span className="sr-only"> (required)</span>}
      </Label>
      <Input
        defaultValue={defaultValue}
        id={name}
        placeholder={placeholder}
        type="number"
        {...register(name, { required })}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
